<template>
<div class="chapter">
<div class="inner_page">
<h1 class="titlepage"><a id="page_iii"></a><i>Back in<br/>Charge!</i></h1>
<p class="subtitle">A Guide to Harnessing<br/>the Magic of Your Brain<br/>to Create the Life You’ll Love</p>
<p class="author">A<span class="small">DRIANNE</span> A<span class="small">HERN</span>, P<span class="small">H</span>.D.</p>
<p class="editor"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?6a5d3312